export default (function () {
  return {
    // there's no EDU impression event, so don't log impressions
    logImpression: false,
    text: 'Check Rate'
  };
});